import { IComponentOptions, module } from 'angular';

import { AUTO_SCROLL_DIRECTIVE } from 'core/presentation/autoScroll/autoScroll.directive';
import { MODAL_CLOSE_COMPONENT } from 'core/modal/buttons/modalClose.component';

import './taskMonitor.directive.less';

export const TASKS_MONITOR_DIRECTIVE = 'spinnaker.tasks.monitor.directive';

const ngmodule = module(TASKS_MONITOR_DIRECTIVE, [
  AUTO_SCROLL_DIRECTIVE,
  require('../../modal/modalOverlay.directive.js').name,
  MODAL_CLOSE_COMPONENT,
  require('./taskMonitorError.component').name,
  require('./taskMonitorStatus.component').name,
]);

ngmodule.directive('taskMonitor', function () {
  return {
    restrict: 'E',
    templateUrl: require('./taskMonitor.html'),
    scope: {
      taskMonitor: '=monitor'
    }
  };
});


export class TaskMonitorWrapperComponent implements IComponentOptions {
  public template = `<task-monitor monitor="$ctrl.monitor"></task-monitor>`;
  public bindings = {
    monitor: '<'
  }
}

ngmodule.component('taskMonitorWrapper', new TaskMonitorWrapperComponent());



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/task/monitor/taskMonitor.directive.ts